export const toggleSections = () => {

  const toggleLink = '.js-toggle-link';

  const init = () => {
    bind();
  };

  const bind = () => {

    $(toggleLink).on('click', function(e) {
      e.preventDefault();
      const element = $(this).data('href');
      $(this).toggleClass('is-active');
      $('#'+element).attr('data-state', $('#'+element).attr('data-state') =='closed' ? 'open' : 'closed');
    });

  };

  init();

};
